import { InfiniteScrollSetup } from "../../components/infinite-scroll/infinite-scroll-setup";

export class ProductsInfiniteScrollSetup {
    public static init(root: HTMLElement): void {
        if (!(root instanceof HTMLElement)) return;
        if (!root.classList.contains("cards-grid")) return;
        if (!root.classList.contains("product")) return;

        InfiniteScrollSetup.init(root, {
            listSelector: ".cards-grid",
            itemSelector: ".product-card--listing",
            paginationSelector: ".pagination-nav",
            nextLinkSelector: 'a[aria-label="Next page"]',
            rootMargin: "260px 0px",
            hidePaginationOnMobile: true,
        });
    }
}
